import { NarrativeCardLoading } from '@/components/NarrativeCard';
import { NARRATIVE_COMMUNITY_LIST_PAGE_SIZE } from '../utils';
import { NarrativeCommunityListLayout } from './NarrativeCommunityListLayout';

const PLACEHOLDER_ITEMS = new Array(NARRATIVE_COMMUNITY_LIST_PAGE_SIZE).fill(0);
export const NarrativeCommunityListSkeleton = () => {
  return (
    <NarrativeCommunityListLayout
      role="presentation"
      aria-label="Loading skeleton"
    >
      {PLACEHOLDER_ITEMS.map((_, index) => (
        <NarrativeCardLoading showCompanyIcon key={index} />
      ))}
    </NarrativeCommunityListLayout>
  );
};
